// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -----------------------------------------------------------------------------
// CABECERA
// ----------------------------------------------------------------------------- */
.main-user.curriculum .cabecera{ margin-bottom: 50px;}

.curriculum .cabecera button:hover,
.curriculum .cabecera a:hover{
    background-color: #007932; 
    color: #fff;
}

.curriculum .cabecera .botones, 
.curriculum .cabecera .botones button
{ gap: 10px; }

.curriculum .cabecera a{
    gap: 10px;
    padding: 10px 20px;
    border: 2px solid #007932;
    border-radius: 12px;
}

/* -----------------------------------------------------------------------------
// ESTILOS GENERALES PARA LAS CAJAS DEL curriculum
// ----------------------------------------------------------------------------- */
.curriculum .cv{
    gap: 56px;
    margin-top: 50px;
}

.caja-verde{
    border: 1px solid #007932;
    border-top: 12px solid #007932;
    border-radius: 25px;
}

.curriculum .cv h2{
    font-size: 18px;
    border-top-left-radius: 7.5px;
    border-top-right-radius: 7.5px;
    padding: 0px 15px 8px 20px;
}

.curriculum ul{list-style: none;}

.curriculum .contenido li{
    border-bottom: 1px solid #007932;
    padding: 7.5px 5px 2.5px 5px;
    flex-wrap: wrap;
}

.curriculum .contenido p{
    padding: 7.5px 5px 2.5px 5px;
}

.curriculum .contenido.documentos li:last-child, .curriculum .contenido .titulo{ border-bottom: none; }


/* -----------------------------------------------------------------------------
// COLUMNA IZQUIERDA
// ----------------------------------------------------------------------------- */
.curriculum .columna-izquierda{
    min-width: 390px;
    max-width: 390px;
    gap: 25px;
}

.curriculum .estado-usuario button{ 
    padding: 0px;
    border: none;
    color: #10AAA0;
    margin-right: 5px;
}

.curriculum .estado-usuario svg{ font-size: 21px; }
.curriculum .estado-usuario p{ padding-bottom: 6px; }

.curriculum .estado-usuario button:hover{ background-color: #fff; }
.curriculum .estado-usuario button:hover svg{  color: #8E151D; }

.curriculum .estado-conexion{margin-left: 20px;}
.curriculum .estado-conexion p{margin-bottom: 0px;}

/* - Datos personales - */
.curriculum .personal{
    border: 1px solid #007932;
    border-bottom: 15px solid #007932;
    padding: 28px 32px 32px 32px;
    border-radius: 28px;
    gap: 20px;
}

.curriculum .personal p{margin-bottom: 0px;}

.curriculum .personal .foto-nombre{ 
    align-items: flex-end;
    gap: 15px;
    margin-bottom: 7.5px;
}

.curriculum .personal img{
    width: 90px;
    border-radius: 50%;
}

.curriculum .personal .foto-nombre p{ 
    font-size: 18px;
    line-height: 1.2;
    margin-bottom: 5px;
}

.curriculum .personal .datos-genericos p:last-child{ text-align: end; }

.curriculum .personal svg{
    margin-right: 10px;
    font-size: 18px;
}

.curriculum .columna-izquierda .contenido{ padding: 7.5px 15px 15px 15px; }
.curriculum .columna-izquierda li span{ flex:1 1; }
.curriculum .columna-izquierda .nivel{ max-width: 150px; }

/* -----------------------------------------------------------------------------
// COLUMNA DERECHA
// ----------------------------------------------------------------------------- */
.curriculum .columna-derecha{ gap: 25px; }

.curriculum .columna-derecha h2{
    gap: 15px;
    font-weight: 400;
    padding: 0px 15px 8px 25px;
}

.curriculum .cv h2 svg{
    font-size: 24px;
    gap: 20px;
}

.curriculum .columna-derecha .contenido{ padding: 15px 25px 15px 22.5px; }
.curriculum .columna-derecha h3{ margin-bottom: 7.5px; }

.curriculum .columna-derecha .contenido .competencia{ 
    width:550px; 
    max-width: 50%;
}

.curriculum .columna-derecha .contenido .nivel{ width:150px; }

/* -- Caja Experiencia laboral-- */
.curriculum .columna-derecha .ocupaciones .contenido{gap: 15px;}

.curriculum .columna-derecha .experiencia, .formulario-cv .experiencia{
    background-color: #D0FDD7;
    padding: 20px;
    border-radius: 12px;
}

.curriculum .columna-derecha .experiencia h3, .formulario-cv .experiencia h3{ margin-bottom: 5px; }

.curriculum .columna-derecha .experiencia .datos p, .formulario-cv .experiencia .datos p{
    margin: 0px;
    padding: 0px;
    font-weight: lighter;
}

.curriculum .columna-derecha .experiencia svg, .formulario-cv .experiencia svg{ 
    margin-left: 7.5px; 
    font-size: 18px;
}

.curriculum .columna-derecha .experiencia .tareas, .formulario-cv .experiencia .tareas{ margin-top: 20px; }

.curriculum .columna-derecha .experiencia .tareas p, .formulario-cv .experiencia .tareas p{
    margin-bottom: 2.5px;
    padding: 0px;
}


/* -- Caja Situación Socioeconómica-- */
.curriculum .columna-derecha .prestaciones{ width: 300px; }
.curriculum .columna-derecha .conciliacion{ width: calc( 100% - 500px); }
.curriculum .columna-derecha .vivienda{ width: 150px; }

.curriculum .columna-derecha .checkbox div{ 
    width: 175px; 
    gap: 5px;
}

.curriculum .columna-derecha .check{ 
    gap: 5px; 
    margin-bottom: 15px;
}

.curriculum .columna-derecha .conciliacion h3{ margin-bottom: 0px; }
.curriculum .columna-derecha .conciliacion .checkbox div { width: 100%; }

/* Estilos para la edición de nombre y apellidos */
.curriculum .personal .nombre-apellidos {
    position: relative;
}

.curriculum .personal .edit-nombre-icon {
    position: absolute;
    top: 5px;
    right: -25px;
    cursor: pointer;
    color: #007932;
    font-size: 16px;
}

.curriculum .personal .edit-nombre-icon:hover {
    color: #005a24;
}

.curriculum .personal .input-nombre,
.curriculum .personal .input-apellido {
    padding: 8px 12px;
    border: 2px solid #007932;
    border-radius: 8px;
    font-size: 16px;
    font-weight: bold;
    width: 100%;
    max-width: 250px;
}

.curriculum .personal .input-nombre:focus,
.curriculum .personal .input-apellido:focus {
    outline: none;
    border-color: #005a24;
    box-shadow: 0 0 5px rgba(0, 121, 50, 0.3);
}

.curriculum .personal .input-nombre::placeholder,
.curriculum .personal .input-apellido::placeholder {
    color: #c0c0c0;
    opacity: 1;
}

/* Estilos para inputs en modo edición de experiencia y formación */
.curriculum .experiencia input,
.curriculum .experiencia select,
.curriculum .experiencia textarea {
    color: #333 !important;
    font-weight: normal !important;
    border: 2px solid #007932;
    border-radius: 8px;
    padding: 8px 12px;
}

.curriculum .experiencia input:focus,
.curriculum .experiencia select:focus,
.curriculum .experiencia textarea:focus {
    outline: none;
    border-color: #005a24;
    box-shadow: 0 0 5px rgba(0, 121, 50, 0.3);
}

.curriculum .experiencia input::placeholder,
.curriculum .experiencia textarea::placeholder {
    color: #999 !important;
    font-weight: normal !important;
    opacity: 0.8;
}
  `, "",{"version":3,"sources":["webpack://./src/pages/user/css/Curriculum.css"],"names":[],"mappings":"AAAA;;kFAEkF;AAClF,iCAAiC,mBAAmB,CAAC;;AAErD;;IAEI,yBAAyB;IACzB,WAAW;AACf;;AAEA;;EAEE,SAAS,EAAE;;AAEb;IACI,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;kFAEkF;AAClF;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA,eAAe,gBAAgB,CAAC;;AAEhC;IACI,gCAAgC;IAChC,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,4BAA4B;AAChC;;AAEA,iFAAiF,mBAAmB,EAAE;;;AAGtG;;kFAEkF;AAClF;IACI,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,iBAAiB;AACrB;;AAEA,iCAAiC,eAAe,EAAE;AAClD,+BAA+B,mBAAmB,EAAE;;AAEpD,0CAA0C,sBAAsB,EAAE;AAClE,+CAA+C,cAAc,EAAE;;AAE/D,6BAA6B,iBAAiB,CAAC;AAC/C,+BAA+B,kBAAkB,CAAC;;AAElD,yBAAyB;AACzB;IACI,yBAAyB;IACzB,iCAAiC;IACjC,4BAA4B;IAC5B,mBAAmB;IACnB,SAAS;AACb;;AAEA,wBAAwB,kBAAkB,CAAC;;AAE3C;IACI,qBAAqB;IACrB,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,qDAAqD,eAAe,EAAE;;AAEtE;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA,2CAA2C,6BAA6B,EAAE;AAC1E,wCAAwC,QAAM,EAAE;AAChD,uCAAuC,gBAAgB,EAAE;;AAEzD;;kFAEkF;AAClF,8BAA8B,SAAS,EAAE;;AAEzC;IACI,SAAS;IACT,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,SAAS;AACb;;AAEA,yCAAyC,8BAA8B,EAAE;AACzE,iCAAiC,oBAAoB,EAAE;;AAEvD;IACI,WAAW;IACX,cAAc;AAClB;;AAEA,gDAAgD,WAAW,EAAE;;AAE7D,kCAAkC;AAClC,qDAAqD,SAAS,CAAC;;AAE/D;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;AAEA,8EAA8E,kBAAkB,EAAE;;AAElG;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA,wFAAwF,gBAAgB,EAAE;;AAE1G;IACI,oBAAoB;IACpB,YAAY;AAChB;;;AAGA,uCAAuC;AACvC,4CAA4C,YAAY,EAAE;AAC1D,4CAA4C,0BAA0B,EAAE;AACxE,wCAAwC,YAAY,EAAE;;AAEtD;IACI,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,QAAQ;IACR,mBAAmB;AACvB;;AAEA,+CAA+C,kBAAkB,EAAE;AACnE,2DAA2D,WAAW,EAAE;;AAExE,kDAAkD;AAClD;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,yCAAyC;AAC7C;;AAEA;;IAEI,cAAc;IACd,UAAU;AACd;;AAEA,mEAAmE;AACnE;;;IAGI,sBAAsB;IACtB,8BAA8B;IAC9B,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;;IAGI,aAAa;IACb,qBAAqB;IACrB,yCAAyC;AAC7C;;AAEA;;IAEI,sBAAsB;IACtB,8BAA8B;IAC9B,YAAY;AAChB","sourcesContent":["/* -----------------------------------------------------------------------------\n// CABECERA\n// ----------------------------------------------------------------------------- */\n.main-user.curriculum .cabecera{ margin-bottom: 50px;}\n\n.curriculum .cabecera button:hover,\n.curriculum .cabecera a:hover{\n    background-color: #007932; \n    color: #fff;\n}\n\n.curriculum .cabecera .botones, \n.curriculum .cabecera .botones button\n{ gap: 10px; }\n\n.curriculum .cabecera a{\n    gap: 10px;\n    padding: 10px 20px;\n    border: 2px solid #007932;\n    border-radius: 12px;\n}\n\n/* -----------------------------------------------------------------------------\n// ESTILOS GENERALES PARA LAS CAJAS DEL curriculum\n// ----------------------------------------------------------------------------- */\n.curriculum .cv{\n    gap: 56px;\n    margin-top: 50px;\n}\n\n.caja-verde{\n    border: 1px solid #007932;\n    border-top: 12px solid #007932;\n    border-radius: 25px;\n}\n\n.curriculum .cv h2{\n    font-size: 18px;\n    border-top-left-radius: 7.5px;\n    border-top-right-radius: 7.5px;\n    padding: 0px 15px 8px 20px;\n}\n\n.curriculum ul{list-style: none;}\n\n.curriculum .contenido li{\n    border-bottom: 1px solid #007932;\n    padding: 7.5px 5px 2.5px 5px;\n    flex-wrap: wrap;\n}\n\n.curriculum .contenido p{\n    padding: 7.5px 5px 2.5px 5px;\n}\n\n.curriculum .contenido.documentos li:last-child, .curriculum .contenido .titulo{ border-bottom: none; }\n\n\n/* -----------------------------------------------------------------------------\n// COLUMNA IZQUIERDA\n// ----------------------------------------------------------------------------- */\n.curriculum .columna-izquierda{\n    min-width: 390px;\n    max-width: 390px;\n    gap: 25px;\n}\n\n.curriculum .estado-usuario button{ \n    padding: 0px;\n    border: none;\n    color: #10AAA0;\n    margin-right: 5px;\n}\n\n.curriculum .estado-usuario svg{ font-size: 21px; }\n.curriculum .estado-usuario p{ padding-bottom: 6px; }\n\n.curriculum .estado-usuario button:hover{ background-color: #fff; }\n.curriculum .estado-usuario button:hover svg{  color: #8E151D; }\n\n.curriculum .estado-conexion{margin-left: 20px;}\n.curriculum .estado-conexion p{margin-bottom: 0px;}\n\n/* - Datos personales - */\n.curriculum .personal{\n    border: 1px solid #007932;\n    border-bottom: 15px solid #007932;\n    padding: 28px 32px 32px 32px;\n    border-radius: 28px;\n    gap: 20px;\n}\n\n.curriculum .personal p{margin-bottom: 0px;}\n\n.curriculum .personal .foto-nombre{ \n    align-items: flex-end;\n    gap: 15px;\n    margin-bottom: 7.5px;\n}\n\n.curriculum .personal img{\n    width: 90px;\n    border-radius: 50%;\n}\n\n.curriculum .personal .foto-nombre p{ \n    font-size: 18px;\n    line-height: 1.2;\n    margin-bottom: 5px;\n}\n\n.curriculum .personal .datos-genericos p:last-child{ text-align: end; }\n\n.curriculum .personal svg{\n    margin-right: 10px;\n    font-size: 18px;\n}\n\n.curriculum .columna-izquierda .contenido{ padding: 7.5px 15px 15px 15px; }\n.curriculum .columna-izquierda li span{ flex:1; }\n.curriculum .columna-izquierda .nivel{ max-width: 150px; }\n\n/* -----------------------------------------------------------------------------\n// COLUMNA DERECHA\n// ----------------------------------------------------------------------------- */\n.curriculum .columna-derecha{ gap: 25px; }\n\n.curriculum .columna-derecha h2{\n    gap: 15px;\n    font-weight: 400;\n    padding: 0px 15px 8px 25px;\n}\n\n.curriculum .cv h2 svg{\n    font-size: 24px;\n    gap: 20px;\n}\n\n.curriculum .columna-derecha .contenido{ padding: 15px 25px 15px 22.5px; }\n.curriculum .columna-derecha h3{ margin-bottom: 7.5px; }\n\n.curriculum .columna-derecha .contenido .competencia{ \n    width:550px; \n    max-width: 50%;\n}\n\n.curriculum .columna-derecha .contenido .nivel{ width:150px; }\n\n/* -- Caja Experiencia laboral-- */\n.curriculum .columna-derecha .ocupaciones .contenido{gap: 15px;}\n\n.curriculum .columna-derecha .experiencia, .formulario-cv .experiencia{\n    background-color: #D0FDD7;\n    padding: 20px;\n    border-radius: 12px;\n}\n\n.curriculum .columna-derecha .experiencia h3, .formulario-cv .experiencia h3{ margin-bottom: 5px; }\n\n.curriculum .columna-derecha .experiencia .datos p, .formulario-cv .experiencia .datos p{\n    margin: 0px;\n    padding: 0px;\n    font-weight: lighter;\n}\n\n.curriculum .columna-derecha .experiencia svg, .formulario-cv .experiencia svg{ \n    margin-left: 7.5px; \n    font-size: 18px;\n}\n\n.curriculum .columna-derecha .experiencia .tareas, .formulario-cv .experiencia .tareas{ margin-top: 20px; }\n\n.curriculum .columna-derecha .experiencia .tareas p, .formulario-cv .experiencia .tareas p{\n    margin-bottom: 2.5px;\n    padding: 0px;\n}\n\n\n/* -- Caja Situación Socioeconómica-- */\n.curriculum .columna-derecha .prestaciones{ width: 300px; }\n.curriculum .columna-derecha .conciliacion{ width: calc( 100% - 500px); }\n.curriculum .columna-derecha .vivienda{ width: 150px; }\n\n.curriculum .columna-derecha .checkbox div{ \n    width: 175px; \n    gap: 5px;\n}\n\n.curriculum .columna-derecha .check{ \n    gap: 5px; \n    margin-bottom: 15px;\n}\n\n.curriculum .columna-derecha .conciliacion h3{ margin-bottom: 0px; }\n.curriculum .columna-derecha .conciliacion .checkbox div { width: 100%; }\n\n/* Estilos para la edición de nombre y apellidos */\n.curriculum .personal .nombre-apellidos {\n    position: relative;\n}\n\n.curriculum .personal .edit-nombre-icon {\n    position: absolute;\n    top: 5px;\n    right: -25px;\n    cursor: pointer;\n    color: #007932;\n    font-size: 16px;\n}\n\n.curriculum .personal .edit-nombre-icon:hover {\n    color: #005a24;\n}\n\n.curriculum .personal .input-nombre,\n.curriculum .personal .input-apellido {\n    padding: 8px 12px;\n    border: 2px solid #007932;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: bold;\n    width: 100%;\n    max-width: 250px;\n}\n\n.curriculum .personal .input-nombre:focus,\n.curriculum .personal .input-apellido:focus {\n    outline: none;\n    border-color: #005a24;\n    box-shadow: 0 0 5px rgba(0, 121, 50, 0.3);\n}\n\n.curriculum .personal .input-nombre::placeholder,\n.curriculum .personal .input-apellido::placeholder {\n    color: #c0c0c0;\n    opacity: 1;\n}\n\n/* Estilos para inputs en modo edición de experiencia y formación */\n.curriculum .experiencia input,\n.curriculum .experiencia select,\n.curriculum .experiencia textarea {\n    color: #333 !important;\n    font-weight: normal !important;\n    border: 2px solid #007932;\n    border-radius: 8px;\n    padding: 8px 12px;\n}\n\n.curriculum .experiencia input:focus,\n.curriculum .experiencia select:focus,\n.curriculum .experiencia textarea:focus {\n    outline: none;\n    border-color: #005a24;\n    box-shadow: 0 0 5px rgba(0, 121, 50, 0.3);\n}\n\n.curriculum .experiencia input::placeholder,\n.curriculum .experiencia textarea::placeholder {\n    color: #999 !important;\n    font-weight: normal !important;\n    opacity: 0.8;\n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
